import React from 'react'
import classes from "./Second.module.scss"
import Button from '../../GlobalComponents/Button/Button'
import img1 from "../../../assets/img/MainPage/2/1.png"
import img1Mob from "../../../assets/img/MainPage/2/1mob.png"

const Second = () => {
    return (
        <div className={[classes.second, ""].join(" ")}>
            <div className={[classes.secondBody, ""].join(" ")}>
                <div className={[classes.secondRow, ""].join(" ")}>
                    <div className={[classes.secondRowLeft, ""].join(" ")}>
                        <h2 className={[classes.secondRowLeftTitle, ""].join(" ")}>
                            We treat your pet as a family member
                        </h2>
                        <p className={[classes.secondRowLeftSubtitle, ""].join(" ")}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at.
                        </p>
                        <div className={[classes.secondRowLeftBtn, ""].join(" ")}>
                            <Button>Discover</Button>
                        </div>


                    </div>
                    <div className={[classes.secondRowRight, ""].join(" ")}>
                        <img src={img1} alt="" />
                        <img src={img1Mob} alt="" />
                    </div>

                </div>

            </div>

        </div>

    )
}

export default Second